import { render, staticRenderFns } from "./Consolidado.vue?vue&type=template&id=23f7e87f&"
import script from "./Consolidado.vue?vue&type=script&lang=js&"
export * from "./Consolidado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports